export default __webpack_public_path__ + "static/media/check-email-banner.949151e3.png";